import config from "~/config";
import {BlackWhiteList} from "~/util/black-white-list";

const allAspects = Object.keys(config("aspects"));
export const EnabledAspectsBlackWhiteList = BlackWhiteList.fromConfig("ui.enabledAspects");
export const ENABLED_ASPECTS = EnabledAspectsBlackWhiteList.apply(allAspects);
